/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ since: NonNullable<unknown> }} Vendor_Return_Waiting_On_ResendInputs */

const en_vendor_return_waiting_on_resend = /** @type {(inputs: Vendor_Return_Waiting_On_ResendInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waiting on Logistics · a message refused · since ${i?.since}`)
};

/**
* | output |
* | --- |
* | "Waiting on Logistics · a message refused · since {since}" |
*
* @param {Vendor_Return_Waiting_On_ResendInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const vendor_return_waiting_on_resend = /** @type {((inputs: Vendor_Return_Waiting_On_ResendInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vendor_Return_Waiting_On_ResendInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_vendor_return_waiting_on_resend(inputs)
});